// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2OEuA","choiceBoxes":"toolbarselects_choiceBoxes__38Hdx","simpleField":"toolbarselects_simpleField__3pNX1"};